import React from 'react';
import PropTypes from 'prop-types';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';

function CustomTimePicker({ value, setFieldValue, name, label }) {
  return (
    <TextField
      id="time"
      value={value}
      label={label}
      type="time"
      variant="standard"
      onChange={(e) => setFieldValue(name, e.target.value)}
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        step: 300,
      }}
      sx={{ width: '100%' }}
    />
  );
}

CustomTimePicker.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default CustomTimePicker;
